module.exports = __webpack_public_path__ + "img/green-pita-05.41d660a8.png";